import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";

import { useExportacionesContext } from "../exportaciones-context";

export function ExportacionesTable() {
  const navigate = useNavigate();

  const { exportaciones, deleteExportacion, verifyExportacion } =
    useExportacionesContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Exportaciones</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!exportaciones.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {["#", "Exportacion", "Estado", "Opciones"].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {exportaciones.map((exportacion, index) => (
                <TableRow key={exportacion.exportacion_id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        {exportacion.exportacion_detalles}
                      </Typography>

                      {!!exportacion.exportacion_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>
                  </TableCell>

                  {/* <TableCell>
                    <Chip
                      label={
                        !!exportacion.exportacion_verificada
                          ? "Verificada"
                          : "Pendiente"
                      }
                      color={
                        !!exportacion.exportacion_verificada
                          ? "success"
                          : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!exportacion.exportacion_verificada ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyExportacion({
                                exportacionId: exportacion.exportacion_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${exportacion.exportacion_id}/edit`)
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deleteExportacion({
                                exportacionId: exportacion.exportacion_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin exportaciones
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
